import React from "react"
import _ from "lodash"

interface IPropsFromParent {
  children: React.ReactNode
  className?: string
  isDark?: boolean
  hasBorder?: boolean
}

type IProps = IPropsFromParent

const DetailsCard: React.FC<IProps> = ({
  children,
  className,
  isDark = false,
  hasBorder = true
}: IProps): JSX.Element => {
  const defaultClasses = [
    "flex",
    "flex-1",
    "flex-col sm:flex-row",
    "mb-2",
    "items-center",
    "flex-wrap",
    "justify-center",
    "lg:justify-between",
    "md:flex-nowrap"
  ]

  const borderClasses = [
    "border",
    "border-ch-gray-400",
    "rounded-md",
    "p-4",
  ]

  const backgroundColourClass = isDark ? "bg-ch-gray-300" : "bg-white"
  const propClasses = className ? className.split(" ") : []
  let allClasses = [...defaultClasses, backgroundColourClass, ...propClasses]
  if(hasBorder) {
    allClasses = [...allClasses, ...borderClasses]
  }


  return (
    <div className={allClasses.join(" ")}>
      { children }
    </div>
  )
}

export default DetailsCard
